// i18n area 'hci' — locale sk-SK (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/hci.sk-SK.meta.json.
import type { enUS } from './hci'

export const skSK: typeof enUS = {
  hci: {
    ceph: {
      title: 'Klastre Ceph',
      createButton: 'Vytvoriť klaster Ceph',
      emptyTitle: 'Žiadny spravovaný klaster Ceph',
      emptyBody: 'TVirt nasadzuje a vlastní Ceph na členských uzloch, hyperkonvergovane so záťažou VM. Vytvorte klaster: prvý monitor a jeho manager sa zrodia automaticky na zvolenom riadiacom uzle — potom ho rozšírte o ďalšie monitory a zariadenia OSD.',
      pageTitle: 'Klastre Ceph',
      colState: 'Stav',
      colMembers: 'Členovia',
      colSize: 'Veľkosť',
      colVersion: 'Verzia Ceph',
      sizeCell: '{used} GiB použitých z {total} GiB celkom',
      phase: {
        'not-deployed': 'Nenasadený',
        deploying: 'Prebieha nasadzovanie',
        healthy: 'Zdravý',
        degraded: 'Degradovaný',
        error: 'Chyba',
        destroying: 'Prebieha zničenie',
        destroyed: 'Zničený'
      },
      health: {
        HEALTH_OK: 'Zdravý (HEALTH_OK)',
        HEALTH_WARN: 'S upozorneniami (HEALTH_WARN)',
        HEALTH_ERR: 'V chybe (HEALTH_ERR)',
        unknown: 'Zatiaľ nepozorované',
        observedAt: 'pozorované {time}'
      },
      create: {
        title: 'Vytvoriť klaster Ceph',
        info: 'Pri vytváraní nového klastra Ceph sa volí prvý uzol, na ktorý sa nainštalujú roly MON a MGR. Treba tiež určiť, ktorá podsieť sa má použiť pre prevádzku Ceph: podsieť public slúži všeobecnej sieťovej prevádzke, zatiaľ čo podsieť cluster sa používa na interné repliky medzi OSD; rozdielne podsiete nie sú striktne nutné.',
        controlNode: 'Riadiaci uzol',
        controlNodeHint: 'Členský uzol, na ktorom sa zrodí prvý MON + MGR.',
        publicSubnet: 'Podsieť public',
        publicSubnetHint: 'Subnet registrovaná v IPAM — public_network Ceph. Po vytvorení nemenná.',
        clusterSubnet: 'Podsieť cluster',
        clusterSubnetHint: 'Subnet registrovaná v IPAM — cluster_network Ceph (replikácia/backfill).',
        noSubnets: 'Žiadna Subnet nie je registrovaná — najprv ich vytvorte v IPAM',
        sameSubnet: 'Rovnaká podsieť pre prevádzku public aj cluster',
        sameSubnetHint: 'Zaškrtnuté = sieť cluster (replikácia/backfill) sa zhoduje so sieťou public. Nezaškrtnuté = vyberte jej vlastnú podsieť A adresu riadiaceho uzla v nej.',
        controlAddress: 'Adresa riadiaceho uzla',
        controlAddressHint: 'Adresa, ktorú IPAM pozná pre uzol v podsieti public.',
        controlClusterAddress: 'Adresa cluster riadiaceho uzla',
        controlClusterAddressHint: 'Adresa, ktorú IPAM pozná pre uzol v podsieti cluster.',
        noAddresses: 'IPAM nepozná žiadnu adresu tohto uzla vo zvolenej podsieti',
        started: 'Klaster vytvorený — bootstrap pokračuje ako makroúloha; fáza sa aktualizuje sama',
        error: 'Klaster bol odmietnutý'
      },
      detail: {
        actions: 'Dostupné akcie',
        tabOverview: 'Prehľad',
        tabManagementNodes: 'MON & MGR',
        tabDisks: 'OSD',
        tabPools: 'Pooly',
        tabObjects: 'Objekty',
        tabCrush: 'CRUSH Map',
        tabCephfs: 'CephFS',
        tabAdvanced: 'Rozšírené',
        phase: 'Fáza',
        checksTitle: 'Aktívne kontroly zdravia',
        noChecks: 'Žiadna aktívna kontrola zdravia',
        checkMuted: 'stlmené',
        summaryPools: 'Pooly',
        summaryFilesystems: 'Filesystemy',
        nodesCard: 'Uzly',
        monHint: 'S každým MON beží kolokovaný MGR. Tri MON tvoria odporúčané kvórum; laboratórny klaster štartuje s jedným. OSD a MDS žijú vo vlastných kartách.',
        monHintSplit: 'MON a MGR sú na tomto klastri oddelené (Rozšírené): každá rola má vlastné členstvo podľa uzlov. Tri MON tvoria odporúčané kvórum; aspoň jeden MGR musí existovať.',
        noMons: 'Žiadny monitor nie je deklarovaný',
        addNode: 'Pridať uzol',
        removeNode: 'Odobrať uzol',
        removeNodeFrom: 'Odobrať uzol {node} (jeho MON a kolokovaný MGR)',
        roleMon: 'Rola MON',
        roleMgr: 'Rola MGR',
        roleNa: 'N/A',
        roleNotObserved: 'zatiaľ nepozorovaná',
        monInQuorum: 'v kvóre',
        monOutQuorum: 'mimo kvóra',
        mgrActive: 'aktívny',
        mgrStandby: 'standby',
        addRoleMon: 'Pridať rolu MON',
        removeRoleMon: 'Odobrať rolu MON',
        addRoleMgr: 'Pridať rolu MGR',
        removeRoleMgr: 'Odobrať rolu MGR',
        restartMon: 'Reštartovať službu MON',
        restartMgr: 'Reštartovať službu MGR',
        addMon: 'Pridať MON',
        removeMon: 'Odobrať MON',
        removeMonFrom: 'Odobrať rolu MON z uzla {node}',
        addMgr: 'Pridať MGR',
        removeMgr: 'Odobrať MGR',
        removeMgrFrom: 'Odobrať rolu MGR z uzla {node}',
        addMds: 'Pridať MDS',
        removeMds: 'Odobrať MDS',
        removeMdsFrom: 'Odobrať rolu MDS z uzla {node}',
        mdsSection: 'Metadátové servery (MDS)',
        noMds: 'Žiadny MDS nie je deklarovaný — filesystem najprv jeden vyžaduje',
        mdsHint: 'Členstvo MDS je vlastné od prvého dňa: klaster bez CephFS žiadne nedeklaruje, jeden aktívny plus jeden standby obslúžia filesystem dobre. Aktívnych a standby volí Ceph spomedzi deklarovaných daemonov.',
        mdsActiveFor: 'aktívny — {fs}',
        mdsNotObserved: 'zatiaľ nepozorovaný',
        lastMdsGuard: 'Posledný MDS nemožno odobrať, kým existuje filesystem — najprv odoberte filesystemy',
        lastMonGuard: 'Posledný MON nemožno odobrať — jediným východiskom je zničiť klaster',
        lastMgrGuard: 'Posledný MGR nemožno odobrať — spravovaný klaster nikdy nebeží bez managera',
        registerDevice: 'Pridať OSD',
        unregisterDevice: 'Zrušiť registráciu',
        activeDeviceGuard: 'Aktívny OSD — odchádza cez životný cyklus OSD, nie cez register',
        colNode: 'Uzol',
        devicePhase: { registered: 'Registrované', active: 'Aktívne' },
        health: 'Zdravie',
        state: 'Stav',
        fsid: 'fsid',
        fsidPending: 'chýba — zopakujte bootstrap',
        version: 'Verzia Ceph',
        publicNetwork: 'Sieť public',
        clusterNetwork: 'Sieť cluster',
        clusterNetworkCollapsed: '= public',
        noActions: 'V tejto fáze nie je dostupná žiadna akcia',
        destroyedNote: 'Klaster zničený — riadok sa onedlho automaticky odstráni'
      },
      overview: {
        services: 'Služby',
        ok: 'zdravé',
        warning: 'warning',
        down: 'mimo prevádzky',
        pgTitle: 'Stavy PG',
        pgTotal: '{n} PG celkom',
        capacityTitle: 'Kapacita',
        ioTitle: 'Aktuálne I/O',
        ioReadBw: 'Priepustnosť čítania',
        ioWriteBw: 'Priepustnosť zápisu',
        ioReadIops: 'IOPS čítania',
        ioWriteIops: 'IOPS zápisu',
        notObserved: 'zatiaľ nepozorované'
      },
      osd: {
        colId: 'ID',
        colClass: 'Device class',
        colState: 'Stav',
        colSize: 'Veľkosť',
        colPgs: 'PG',
        empty: 'Žiadny OSD — pridajte jeden z deklarovaného dátového disku',
        markIn: 'Označiť IN',
        markOut: 'Označiť OUT',
        scrub: 'Spustiť scrub',
        deepScrub: 'Spustiť hlboký scrub',
        restart: 'Reštartovať službu',
        details: 'Podrobnosti',
        actionGuard: 'Len na aktívnom OSD nasadeného klastra',
        inTitle: 'Označiť OSD IN',
        inBody: 'osd.{id} sa vracia do distribúcie dát (ceph osd in): Ceph naň dáta vyváži späť.',
        outTitle: 'Označiť OSD OUT',
        outBody: 'osd.{id} opúšťa distribúciu dát (ceph osd out): jeho dáta sa prevážia inam a redundancia je ZNÍŽENÁ, kým beží backfill. Kedykoľvek vratné cez Označiť IN.',
        scrubTitle: 'Naplánovať scrub',
        scrubBody: 'Naplánuje sa scrub osd.{id}: monitor ho zaradí do fronty a výsledok ukážu stavy PG v nasledujúcich sweepoch.',
        deepScrubTitle: 'Naplánovať hlboký scrub',
        deepScrubBody: 'Naplánuje sa hlboký scrub osd.{id}: variant, ktorý overuje bajty — náročnejší na I/O, rovnaká mechanika.',
        restartTitle: 'Reštartovať službu OSD',
        restartBody: 'osd.{id} sa zastaví a znova spustí cez vlastný dohľad workera na jeho uzle.',
        started: 'Akcia spustená — pozorovanie sa aktualizuje samo',
        error: 'Akcia OSD bola odmietnutá'
      },
      osdDetail: {
        title: 'Podrobnosti OSD',
        tabGeneral: 'Všeobecné',
        tabNetwork: 'Sieť',
        tabDevices: 'Zariadenia',
        version: 'Verzia',
        hostname: 'Hostname',
        dataPath: 'Cesta k dátam OSD',
        objectStore: 'Object store OSD',
        encrypted: 'Šifrované',
        yes: 'Áno',
        no: 'Nie',
        memory: 'Využitie pamäte (PSS)',
        pid: 'Process ID (PID)',
        front: 'Adresa front (klient & monitor)',
        hbFront: 'Adresa heartbeat front',
        back: 'Adresa back (OSD)',
        hbBack: 'Adresa heartbeat back',
        colDevice: 'Device',
        colType: 'Typ',
        colPhysical: 'Fyzický device',
        colSize: 'Veľkosť',
        volumeTitle: 'Podrobnosti zväzku',
        creationTime: 'Dátum vytvorenia',
        lvName: 'LV Name',
        lvPath: 'LV Path',
        lvUuid: 'LV UUID',
        vgName: 'VG Name',
        noDevices: 'Pre tento OSD nebol pozorovaný žiadny device'
      },
      restart: {
        title: 'Reštartovať službu',
        monBody: 'Daemon MON na uzle {node} sa zastaví a znova spustí cez vlastný dohľad workera.',
        mgrBody: 'Daemon MGR na uzle {node} sa zastaví a znova spustí cez vlastný dohľad workera.',
        started: 'Reštart spustený — pozorovanie sa aktualizuje samo',
        error: 'Reštart bol odmietnutý'
      },
      encryptionMode: {
        alwaysOn: 'Vždy povolené (dmcrypt)',
        alwaysOff: 'Vždy zakázané',
        perOsd: 'Voľba pre každý OSD',
        section: 'Šifrovanie OSD at rest',
        title: 'Zmeniť režim šifrovania OSD',
        hint: 'Ako sa pripravujú NOVÉ OSD. Existujúce OSD si ponechávajú svoj stav podľa disku: na zmenu treba OSD odobrať a znova vytvoriť.',
        body: 'Režim sa zmení na „{mode}“ a platí LEN pre NOVÉ OSD: každý existujúci OSD si ponecháva svoj aktuálny stav šifrovania.',
        apply: 'Zmeniť režim',
        error: 'Zmena režimu bola odmietnutá'
      },
      pin: {
        address: 'Adresa public (voliteľný pin)',
        clusterAddress: 'Adresa cluster (voliteľný pin)',
        autoPlaceholder: 'automaticky v podsieti {cidr}',
        hint: 'Adresovanie per-daemon: prázdne = Ceph sa naviaže sám vnútri deklarovanej siete; vyplnené = táto inštancia daemona je pripnutá na adresu vo svojej sekcii conf.'
      },
      addMon: {
        title: 'Pridať uzol',
        node: 'Uzol',
        address: 'Adresa public',
        addressHint: 'Adresy uzla, ktoré IPAM pozná v podsieti public — automatické, keď uzol pokrýva existujúca deklarácia.',
        clusterAddress: 'Adresa cluster',
        clusterAddressHint: 'Povinné: podsieť cluster je oddelená a uzol na nej ešte nie je deklarovaný.',
        noAddresses: 'IPAM nepozná žiadnu adresu tohto uzla v tejto podsieti',
        error: 'Pridanie monitora bolo odmietnuté'
      },
      removeMon: {
        title: 'Odobrať MON',
        body: 'MON a jeho kolokovaný MGR opúšťajú uzol {node}. Na nasadenom klastri sa daemony zastavia a odoberú z kvóra.',
        error: 'Odobratie MON bolo odmietnuté'
      },
      addMgr: {
        title: 'Pridať MGR',
        node: 'Uzol',
        hint: 'Rozšírené (oddelené MON/MGR): samostatný manager sa zrodí na zvolenom členskom uzle úlohou viazanou na uzol. Aktívny MGR si Ceph zvolí sám vlastnou voľbou active/standby.',
        error: 'Pridanie MGR bolo odmietnuté'
      },
      removeMgr: {
        title: 'Odobrať MGR',
        body: 'Samostatný MGR opúšťa uzol {node}. Na nasadenom klastri sa daemon zastaví a jeho stav odstráni; MON uzla (ak existuje) zostáva nedotknutý.',
        error: 'Odobratie MGR bolo odmietnuté'
      },
      addMds: {
        title: 'Pridať MDS',
        node: 'Uzol',
        hint: 'Metadátový server CephFS: zrodí sa na zvolenom členskom uzle úlohou viazanou na uzol, pod dohľadom workera ako MON a MGR. Aktívnych a standby si Ceph volí sám — jeden aktívny plus jeden standby obslúžia filesystem dobre.',
        error: 'Pridanie MDS bolo odmietnuté'
      },
      removeMds: {
        title: 'Odobrať MDS',
        body: 'MDS opúšťa uzol {node}. Na nasadenom klastri sa daemon zastaví a jeho stav odstráni; API odmietne posledný MDS, kým ho filesystem potrebuje.',
        error: 'Odobratie MDS bolo odmietnuté'
      },
      split: {
        title: 'Oddelené MON/MGR',
        label: 'Povoliť MON a MGR na oddelených uzloch',
        hint: 'Vypnuté (predvolené) = ratifikovaný štandard: s každým MON beží kolokovaný MGR, jediné členstvo. Zapnuté = členstvo MGR sa osamostatní a spravuje sa akciami Pridať/Odobrať MGR na karte Uzly správy.',
        enable: 'Povoliť',
        disable: 'Zakázať',
        enableBody: 'Členstvo MGR sa stane nezávislým od MON, inicializované z aktuálnej kolokácie. Akcie Pridať/Odobrať MGR sa aktivujú na karte Uzly správy. Uvoľňuje sa tým predvolené nastavenie platformy — ponechajte si ho, len ak viete, prečo ho potrebujete.',
        disableBody: 'Návrat k štandardnej kolokácii: MGR s každým MON, jediné členstvo. Legálne, len keď sa členstvo MGR už zhoduje s MON — najprv ho zosúlaďte cez Pridať/Odobrať MGR, inak API odmietne.',
        error: 'Zmena bola odmietnutá'
      },
      rawEditor: {
        title: 'Surový editor CRUSH',
        label: 'Zobraziť surový editor crushmapy na karte CRUSH',
        hint: 'Vypnuté (predvolené) = riadená plocha pravidiel je štandardný nástroj. Zapnuté = karta CRUSH zobrazuje aj dekompilovanú crushmapu ako upraviteľný text. Uloženie vždy vyžaduje sudo, názov klastra ako potvrdenie a PRED dosiahnutím klastra prechádza cez compile + test nástroja crushtool.'
      },
      osdFlags: {
        section: 'Globálne príznaky OSD',
        title: 'Override príznakov OSD',
        notObserved: 'zatiaľ nepozorované',
        standardFlowsHint: 'Štandardné toky platformy spravujú tieto príznaky samy v bežných prípadoch (údržba uzla nastaví cielený noout, výmena disku ide cez životný cyklus OSD). Táto sekcia je manuálny override pre operátora, ktorý vie, čo robí.',
        notDeployedGuard: 'Príznaky OSD existujú len na nasadenom klastri',
        set: 'Nastaviť príznak',
        unset: 'Odobrať príznak',
        setBody: 'Globálny príznak {flag} sa NASTAVÍ v osdmape. Zostane, kým sa explicitne neodoberie — zabudnutý príznak degraduje samoopravu klastra.',
        unsetBody: 'Globálny príznak {flag} sa ODOBERIE z osdmapy.',
        error: 'Zmena príznaku bola odmietnutá',
        flag: {
          noout: 'Žiadny OSD sa neoznačuje out z distribúcie dát — žiadne vyvažovanie pri strate daemona',
          norebalance: 'Vyvažovanie dát je pozastavené',
          nobackfill: 'Backfill je pozastavený',
          norecover: 'Recovery je pozastavené',
          pause: 'VŠETKO klientske I/O je pozastavené (čítania aj zápisy)',
          noin: 'Štartujúce OSD sa automaticky neoznačujú in',
          nodown: 'Nedosiahnuteľné OSD sa neoznačujú down — maskuje skutočné zlyhania'
        }
      },
      pools: {
        section: 'Pooly',
        create: 'Vytvoriť pool',
        createGuard: 'Pooly existujú len na nasadenom klastri',
        notObserved: 'Zatiaľ žiadne pozorovanie poolov — hlási sa tu sweep monitora',
        empty: 'Na klastri nie je žiadny pool',
        colName: 'Názov',
        colReplication: 'Size / min size',
        colPgNum: 'PG',
        colApplication: 'Aplikácia',
        colRule: 'Pravidlo CRUSH',
        colUsage: 'Využitie',
        observedAtLabel: 'Pozorované',
        objects: 'objektov: {n}',
        inUseBy: 'používa ho {name}',
        internalGuard: 'Interný pool Ceph — platforma ho nikdy neodstráni',
        delete: 'Odstrániť pool',
        deleteGuard: 'Spotrebúva ho úložisko {name} — najprv odstráňte úložisko',
        hint: 'Len replikované pooly (erasure coding je mimo rozsahu v1). Replikácia žije v Ceph: táto tabuľka je pravda pozorovaná sweepom monitora.',
        createTitle: 'Vytvoriť pool',
        createHint: 'Pool sa zrodí na klastri s požadovanou replikáciou a povolenou aplikáciou rbd — prácu vykoná úloha na uzle MON. Zapnite „Navrhnúť ako úložisko“, aby ste ho spotrebovali hneď tým istým gestom.',
        name: 'Názov poolu',
        nameHint: 'DNS-safe (malé písmená, číslice, spojovníky).',
        size: 'Repliky (size)',
        sizeHint: 'Kópie každého objektu. Predvolené 3.',
        minSize: 'Minimum replík (min_size)',
        minSizeHint: 'Minimálny počet kópií na obsluhu I/O — sleduje size − 1, kým ho neupravíte.',
        createError: 'Vytvorenie poolu bolo odmietnuté',
        deleteTitle: 'Odstrániť pool',
        deleteBody: 'Pool {pool} a KAŽDÝ objekt v ňom budú nenávratne zničené. Na potvrdenie napíšte názov poolu.',
        confirmLabel: 'Názov poolu',
        confirmHint: 'Na potvrdenie napíšte názov poolu',
        deleteError: 'Odstránenie poolu bolo odmietnuté',
        detailTitle: 'Podrobnosti poolu',
        autoscaler: 'PG Autoscaler',
        autoscalerOn: 'Zapnutý',
        autoscalerOff: 'Vypnutý',
        autoscalerWarn: 'Upozorniť',
        pgNumLabel: 'Počet PG',
        pgNumCaption: 'Pozorované: autoscaler ho môže zmeniť sám — toto pole zapisuje želanie.',
        storage: 'Priradené úložisko TVirt',
        addAsStorage: 'Pridať ako úložisko TVirt',
        ruleSudoHint: 'Zmena pravidla CRUSH vyžaduje heslo operátora.',
        updateError: 'Úprava poolu bola odmietnutá',
        updated: 'Úprava poolu spustená — pozorovanie sa aktualizuje samo'
      },
      crush: {
        section: 'Pravidlá CRUSH',
        notObserved: 'Zatiaľ žiadne pozorovanie CRUSH — hlási sa tu sweep monitora',
        empty: 'Na klastri nebolo pozorované žiadne pravidlo',
        hint: 'Pravidlo rozhoduje, KAM dopadnú kópie každého objektu — jeho doména zlyhania je jednotka, ktorá môže zlyhať bez straty dát. Pooly ukazujú na pravidlo; vstavané pravidlo replicated_rule (jedna replika na server) je predvoľba od zrodu.',
        create: 'Vytvoriť pravidlo',
        createGuard: 'Pravidlá CRUSH existujú len na nasadenom klastri',
        createTitle: 'Vytvoriť pravidlo CRUSH',
        createHint: 'Jedno pravidlo = jedna voľba domény zlyhania. Pravidlo sa zrodí replikované na predvolenom roote — prácu vykoná úloha na uzle MON; pooly k nemu priraďte potom z karty Pooly.',
        createError: 'Vytvorenie pravidla bolo odmietnuté',
        name: 'Názov pravidla',
        nameHint: 'DNS-safe (malé písmená, číslice, spojovníky).',
        domain: 'Doména zlyhania',
        domainChoice: {
          osd: 'Každá replika na inom OSD',
          host: 'Každá replika na inom serveri',
          rack: 'Každá replika v inom racku'
        },
        domainCustom: 'Vlastné (ručne písané kroky)',
        domainOther: 'Každá replika v inom {type}',
        rackGuardHint: 'V pozorovanej hierarchii neexistuje žiadny bucket rack: pravidlo sa aj tak dá vytvoriť, ale žiadny pool naň nebude môcť ukazovať, kým sa rack nedeklaruje v umiestnení členských serverov (nastavenia uzla) — zosúlaďovacia úloha postaví bucket a priradenie sa otvorí samo.',
        treeTitle: 'Pozorovaná hierarchia',
        treeNotObserved: 'Zatiaľ žiadne pozorovanie hierarchie — hlási sa tu sweep monitora',
        treeOsds: '{n} OSD',
        treeHint: 'Mapa CRUSH, ako ju vidí klaster: root → deklarované úrovne → servery (hosty) → OSD. Topológia sleduje deklarované umiestnenie každého servera (nastavenia uzla) — zmena umiestnenia ju zosúladí úlohou.',
        unplacedWarning: 'Členovia bez deklarovaného umiestnenia: {nodes} — ich buckety host zostávajú priamo pod rootom, mimo deklarovanej topológie. Umiestnenie deklarujte v nastaveniach uzla (upozornenie, nikdy nie blokácia).',
        colName: 'Názov',
        colDomain: 'Doména zlyhania',
        colPools: 'Pooly',
        builtinChip: 'builtin',
        builtinGuard: 'Predvolené pravidlo klastra — platforma ho nikdy neodstráni',
        detailAction: 'Podrobnosti pravidla',
        detailType: 'Typ',
        backToRules: 'Pravidlá',
        ruleNotObserved: 'Pozorovaný zoznam pravidiel toto pravidlo nemenuje',
        noPools: 'Na tomto pravidle nejazdí žiadny pool',
        delete: 'Odstrániť pravidlo',
        deleteTitle: 'Odstrániť pravidlo CRUSH',
        deleteBody: 'Pravidlo {rule} sa odstráni z crushmapy klastra. Nesmie na ňom jazdiť žiadny pool. Na potvrdenie napíšte názov pravidla.',
        deleteGuard: 'Jazdí na ňom pool {name} — najprv pool presmerujte',
        confirmLabel: 'Názov pravidla',
        confirmHint: 'Na potvrdenie napíšte názov pravidla',
        deleteError: 'Odstránenie pravidla bolo odmietnuté',
        changeRule: 'Zmeniť pravidlo CRUSH',
        changeRuleTitle: 'Zmeniť pravidlo CRUSH',
        changeRuleHint: 'Pool začne umiestňovať svoje objekty podľa zvoleného pravidla — Ceph presunie existujúce dáta, aby vyhovel (na plnom poole nasleduje vyvažovanie).',
        changeRuleError: 'Zmena pravidla bola odmietnutá',
        rule: 'Pravidlo CRUSH',
        rawTitle: 'Surová crushmapa (dekompilovaná)',
        rawWarning: 'NEBEZPEČENSTVO: tento text je CELÁ politika umiestňovania klastra. Nesprávna mapa môže naraz rozbiť umiestňovanie všetkých poolov. Uloženie mapu skompiluje a otestuje nástrojom crushtool PRED jej vstreknutím — no aj platná mapa môže byť zlý nápad.',
        rawReload: 'Znova načítať',
        rawLoading: 'Dopyt beží — úloha len na čítanie dekompiluje crushmapu…',
        rawSave: 'Uložiť crushmapu',
        rawSaveTitle: 'Vstreknúť crushmapu',
        rawSaveBody: 'Upravený text nahradí crushmapu CELÉHO klastra po compile + test nástroja crushtool. Na potvrdenie napíšte názov klastra.',
        rawConfirmLabel: 'Názov klastra',
        rawConfirmHint: 'Na potvrdenie napíšte {name}',
        rawError: 'Operácia s crushmapou zlyhala',
        rawHint: 'Text je vo forme crushtool -d. Chyby kompilácie a zlyhania testov sa vracajú doslovne z crushtool — mapa sa ku klastru nedostane, ak niektorá z dvoch brán zlyhá.'
      },
      objects: {
        poolsSection: 'Prieskumník objektov',
        poolsHint: 'Vyberte pool a zobrazia sa jeho obrazy RBD. Každé hlboké čítanie beží ako úloha len na čítanie na uzle MON — neblokuje skutočné operácie (ani nie je nimi blokované).',
        deployedGuard: 'Dopyty na objekty odpovedajú len na nasadenom klastri',
        browse: 'Prehliadať objekty',
        detailAction: 'Podrobnosti obrazu',
        backToPools: 'Pooly',
        backToImages: 'Obrazy',
        refresh: 'Obnoviť',
        loading: 'Dopyt beží — úloha len na čítanie sa pýta klastra…',
        error: 'Dopyt zlyhal',
        retry: 'Skúsiť znova',
        notRbd: 'Pool s application „{app}“ — neobsahuje obrazy RBD, nie je tu čo skúmať',
        noImages: 'V tomto poole nie sú žiadne obrazy RBD',
        colImage: 'Obraz',
        colSize: 'Veľkosť',
        colObjects: 'Objekty',
        colSnapshots: 'Snímky',
        imagesHint: 'Disky na konzumujúcom úložisku rbd sú obrazy pomenované podľa id svojho disku. Počet objektov je provisioned (veľkosť / veľkosť objektu) — skutočné využitie žije v podrobnostiach obrazu.',
        infoTitle: 'Obraz',
        infoSize: 'Virtuálna veľkosť',
        infoObjects: 'Objekty (provisioned)',
        infoObjectSize: 'Veľkosť objektu',
        infoPrefix: 'Prefix objektov',
        infoFormat: 'Formát',
        infoFeatures: 'Features',
        usageTitle: 'Skutočné využitie (rbd du)',
        usageOf: 'z {provisioned} GiB provisioned',
        usageHint: 'Thin zo svojej podstaty: bajty zaberajú len zapísané objekty.',
        watchersTitle: 'Watchery',
        noWatchers: 'Žiadny watcher — tento obraz teraz nemá nikto otvorený',
        snapshotsTitle: 'Snímky RBD',
        noSnapshots: 'Na tomto obraze nie je žiadna snímka RBD',
        colSnapshot: 'Snímka',
        colProtected: 'Chránená',
        colTimestamp: 'Vytvorená',
        protected: 'chránená',
        mappingTitle: 'Fyzické mapovanie (množina OSD)',
        mappingSampled: 'Vzorka {sampled} z {total} objektov — poctivé zhrnutie: pri veľkých obrazoch množina konverguje ku KAŽDÉMU OSD poolu (CRUSH rozdeľuje objekty po celom poole).',
        mappingComplete: 'Zmapované všetky objekty ({total} z {total}).',
        objectQueryTitle: 'Zmapovať jeden objekt',
        objectName: 'Názov objektu',
        objectHint: 'Názvy objektov RADOS sú <prefix>.<16-hexový index> — ceph osd map odpovedá PG a trojicami OSD.',
        mapObject: 'Zmapovať',
        primary: 'primárny: osd.{osd}'
      },
      registerDevice: {
        title: 'Registrovať zariadenie OSD',
        hint: 'Na živom klastri registrácia zariadenie aj PRIPRAVÍ: automatickou úlohou viazanou na uzol sa stane OSD BlueStore (nikdy naprázdno, ratifikované 2026-07-24). Zariadenie patrí najviac jednému klastru Ceph v celej flotile.',
        disk: 'Dátový disk',
        diskHint: 'Deklarované dátové disky uzla — názov a sériové číslo',
        noDeclared: 'Na tomto uzle nie sú deklarované žiadne dátové disky — najprv ich označte v lokálnych nastaveniach uzla',
        serialHint: 'Sériové číslo zariadenia — pin identity',
        encrypted: 'Šifrovať tento OSD (dmcrypt)',
        encryptedHint: 'Voľba pre jednotlivý OSD (režim klastra je „voľba pre každý OSD“): pri registrácii sa na tomto disku zmrazí — neskoršia zmena režimu ju nikdy neprepíše; to robí riadková akcia šifrovať/dešifrovať.',
        error: 'Registrácia bola odmietnutá'
      },
      unregisterDevice: {
        title: 'Zrušiť registráciu zariadenia',
        body: 'Len register: {name} prestáva byť kandidátom na OSD tohto klastra. Jeho bajty zostávajú nedotknuté.',
        error: 'Zrušenie registrácie bolo odmietnuté'
      },
      deploy: {
        action: 'Zopakovať nasadenie',
        title: 'Zopakovať bootstrap',
        body: 'Zrodový bootstrap sa spustí znova z aktuálnej konfigurácie: monitory sa naštartujú, každé registrované zariadenie sa pripraví a aktivuje ako OSD BlueStore. Operácia beží ako makroúloha — fáza sa aktualizuje sama.',
        started: 'Bootstrap spustený — pokračuje ako makroúloha; fáza sa aktualizuje sama',
        error: 'Bootstrap bol odmietnutý'
      },
      propose: {
        action: 'Navrhnúť ako úložisko',
        title: 'Navrhnúť ako úložisko',
        hintPool: 'Existujúci pool {name} sa stane úložiskom TVirt: identita cephx obmedzená na pool skončí v keystore a úložisko ceph-rbd sa zrodí pripravené. Návrh pool spotrebúva — nikdy žiadny nevytvára.',
        hintFs: 'Existujúci filesystem {name} sa stane úložiskom TVirt: identita cephx obmedzená na filesystem skončí v keystore a úložisko cephfs sa zrodí pripravené a pripojené. Návrh filesystem spotrebúva — nikdy žiadny nevytvára.',
        name: 'Názov úložiska',
        nameHint: 'DNS-1123, jedinečný v scope — identita cephx sa pomenúva podľa neho.',
        path: 'Cesta vnútri filesystemu',
        pathHint: 'Absolútna cesta vnútri filesystemu, ktorý úložisko pripája — v prípade pochybností /.',
        alsoPropose: 'Hneď navrhnúť ako úložisko',
        alsoProposePoolHint: 'Po vytvorení to isté gesto navrhne novozrodený pool ako úložisko ceph-rbd — dve explicitné volania, jeden dialóg.',
        alsoProposeFsHint: 'Po vytvorení to isté gesto navrhne novozrodený filesystem ako úložisko cephfs — dve explicitné volania, jeden dialóg.',
        guard: 'Navrhnúť ako úložisko — len na healthy klastri',
        started: 'Návrh prijatý — úložisko sa materializuje; nájdete ho v časti Úložisko',
        submit: 'Vytvoriť úložisko',
        error: 'Návrh bol odmietnutý'
      },
      fs: {
        section: 'Filesystemy',
        create: 'Vytvoriť filesystem',
        createGuard: 'Filesystemy existujú len na nasadenom klastri',
        mdsFirstGuard: 'Najprv pridajte MDS — filesystem bez metadátového servera sa zrodí neobslúžiteľný',
        notObserved: 'Zatiaľ žiadne pozorovanie filesystemov — hlási sa tu sweep MON',
        empty: 'Na klastri nie je žiadny filesystem',
        colName: 'Názov',
        colPools: 'Pooly',
        colMds: 'MDS',
        noActiveMds: 'žiadny aktívny MDS',
        delete: 'Odobrať filesystem',
        deleteGuard: 'Spotrebúva ho úložisko {name} — najprv odstráňte úložisko',
        hint: 'Filesystem vlastní svoje dátové a metadátové pooly (cephfs.<názov>.data / .meta): rodia sa s ním a umierajú s ním — removeFs, nikdy holé odstránenie poolu. Táto tabuľka je pravda pozorovaná sweepom MON.',
        createTitle: 'Vytvoriť filesystem',
        createHint: 'Filesystem sa zrodí na klastri so svojimi dvoma poolmi (application cephfs) a obsluhujú ho deklarované MDS — prácu vykoná úloha na uzle MON. Zapnite „Navrhnúť ako úložisko“, aby ste ho spotrebovali hneď tým istým gestom.',
        name: 'Názov filesystemu',
        nameHint: 'DNS-safe (malé písmená, číslice, spojovníky).',
        sizeHint: 'Repliky OBOCH novozrodených poolov. Predvolené 3.',
        createError: 'Vytvorenie filesystemu bolo odmietnuté',
        deleteTitle: 'Odobrať filesystem',
        deleteBody: 'Filesystem {fs} a KAŽDÝ súbor v ňom budú nenávratne zničené — jeho dátové a metadátové pooly umierajú s ním. Na potvrdenie napíšte názov filesystemu.',
        confirmLabel: 'Názov filesystemu',
        confirmHint: 'Na potvrdenie napíšte názov filesystemu',
        deleteError: 'Odobratie filesystemu bolo odmietnuté'
      },
      destroy: {
        action: 'Zničiť',
        retryAction: 'Zopakovať zničenie',
        retryGuard: 'Zničenie práve beží — zopakovanie platí pre zlyhané zničenie (inak ho lease odmietne)',
        title: 'Zničiť klaster',
        body: 'Nasadená fabric sa demontuje: každý daemon tohto klastra sa zastaví, uvoľní sa jeho systémový stav aj kľúče v keystore. Len čo sa demontáž podarí, klaster sa odstráni automaticky.',
        confirmLabel: 'Názov klastra',
        confirmHint: 'Na potvrdenie napíšte názov klastra',
        wipe: 'Vymazať registrované zariadenia',
        wipeHint: 'Zaškrtnuté: podpisy každého registrovaného zariadenia sa vymažú — dáta na nich sú zničené. Nezaškrtnuté: bajty zostanú nedotknuté a zariadenia sa vrátia medzi registrované.',
        guard: 'Zničiť — nič nie je nasadené',
        started: 'Zničenie spustené — pokračuje ako makroúloha; fáza sa aktualizuje sama',
        error: 'Zničenie bolo odmietnuté'
      },
      delete: {
        guard: 'Odstrániť — len nenasadenú konfiguráciu (najprv zničte)',
        title: 'Odstrániť {name}?',
        body: 'Konfigurácia a jej register zariadení sa odstránia. Legálne, len kým nič nie je nasadené.',
        error: 'Odstránenie bolo odmietnuté'
      }
    }
  }
}
